import i18n from '@/i18n/index'

export default {
  formData: [{
    title: i18n.t('table.product.basicInformation'),
    name: 0,
    createDateItem: [{
      span: 8,
      prop: 'name',
      name: 'input',
      label: 'Name',
      placeholder: i18n.t('placeholder.defaultInput'),
      Object: {
      }
    }, {
      span: 8,
      prop: 'hotel_room_id',
      name: 'select',
      options: [],
      value: [],
      label: 'Hotem Room',
      placeholder: i18n.t('placeholder.defaultSelect'),
      Object: {
        filterable: true
      }
    }, {
      span: 24,
      prop: 'description',
      name: 'input',
      type: 'textarea',
      label: 'Description',
      placeholder: 'Description',
      Object: {
        rows: 4
      }
    }, {
      span: 8,
      prop: 'price',
      name: 'input',
      type: 'number',
      label: 'Price',
      placeholder: 'Price',
      Object: {
      }
    }]
  }]
}
